'use strict';/* global define:false */define('modules/360-feedback/services/360-feedback/index',['angular'],function(ng){'use strict';/*

    ## 360 Feedback
    PUT /three-sixty-feedbacks/requests/:r_id Give 360 feedback for user (accept request)
    DELETE /three-sixty-feedbacks/requests/:r_id Decline 360 feedback for user (drop request)
    GET /three-sixty-feedbacks/user/:u_id List 360 feedbacks for given user

    ## 360 Feedback Config
    GET /three-sixty-feedbacks/configs Get 360° feedback config
    POST DEPRECATED /three-sixty-feedbacks/configs Initial config for 360 feedback
    PATCH /three-sixty-feedbacks/configs/:id Configure 360 feedback Config

    ## 360 Feedback Requests
    GET /three-sixty-feedbacks/requests List your pending 360 feedback requests
    POST /three-sixty-feedbacks/user/:u_id Request 360 feedback
    POST /three-sixty-feedbacks/:id Append requestees to an existing 360 feedback request

   */
model.$inject = ["$resource", "API_ENDPOINT"];var prefix='three-sixty-feedbacks';// @ngInject
function model($resource,API_ENDPOINT){var url=API_ENDPOINT+prefix;// var shortCache = new AmnesiaCache( 1000 );
// var longCache  = new AmnesiaCache( 5000 );
var params={id:'@id'};var actions={forUser:{method:'GET',isArray:true,// cache   : shortCache,
url:url+'/user/:userId'},forPeriod:{method:'GET',isArray:true,url:API_ENDPOINT+'feedback-processes/:periodId/three-sixty-feedbacks'},requestForUser:{method:'POST',url:url+'/user/:userId'},requests:{method:'GET',isArray:true,// cache   : shortCache,
url:url+'/requests'},acceptRequest:{method:'PUT',url:url+'/requests/:requestId'},declineRequest:{method:'DELETE',url:url+'/requests/:requestId'},addParticipants:{method:'POST'},addPartySeaPants:{method:'POST'},config:{method:'GET',url:API_ENDPOINT+prefix+'/configs'},patchConfig:{method:'PATCH',url:API_ENDPOINT+prefix+'/configs/:id'},getFormRevisions:{method:'GET',isArray:true,url:API_ENDPOINT+prefix+'/:id/forms'}};return $resource(url+'/:id',params,actions);}return model;});
